var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSession2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.55,
    viewBox: "0 0 18 17.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_577a1b53ec5ce24f143ebdb283f082d7",
    "data-name": "577a1b53ec5ce24f143ebdb283f082d7",
    d: "M17.054,2.61a.447.447,0,1,0-.585.675,1.663,1.663,0,0,1,.63,1.3V15.03a1.691,1.691,0,0,1-1.665,1.665H2.564A1.691,1.691,0,0,1,.9,15.03V4.59A1.691,1.691,0,0,1,2.564,2.925h6.75a.45.45,0,1,0,0-.9H2.564A2.536,2.536,0,0,0,0,4.59V14.985A2.593,2.593,0,0,0,2.564,17.55H15.389A2.565,2.565,0,0,0,18,15.03V4.59a2.611,2.611,0,0,0-.945-1.98ZM12.644,15.3a.517.517,0,0,0,.4.27.432.432,0,0,0,.4-.27l1.35-2.745a.27.27,0,0,0,.045-.18V1.8a1.8,1.8,0,0,0-3.6,0V12.375a.217.217,0,0,0,.045.18Zm.4-1.215-.63-1.26h1.26ZM12.149,1.8a.9.9,0,1,1,1.8,0V5.67h-1.8Zm0,4.77h1.8v.9h-1.8Zm0,1.845h1.8v3.51h-1.8ZM8.954,7.29H2.744a.45.45,0,1,0,0,.9H9a.416.416,0,0,0,.4-.45.425.425,0,0,0-.45-.45Zm0,1.8H2.744a.45.45,0,1,0,0,.9H9a.416.416,0,0,0,.4-.45.425.425,0,0,0-.45-.45Zm0,1.8H2.744a.45.45,0,1,0,0,.9H9a.416.416,0,0,0,.4-.45.425.425,0,0,0-.45-.45Z",
    transform: "translate(0.001)",
    fill: "#74613c",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession2);
export default __webpack_public_path__ + "static/media/session2.9f9bc2fefd2f8b8f9826ab3f2084e74a.svg";
export { ForwardRef as ReactComponent };